module.exports = __webpack_public_path__ + "img/banner.60f5d352.png";